// extracted by mini-css-extract-plugin
export default {"internalPIUserAccessToggle":"styles_internalPIUserAccessToggle__Ebs6s"};